goog.provide("shadow.js.shim.module$copy_to_clipboard");
goog.provide("module$shadow_js_shim_module$copy_to_clipboard");
shadow.js.shim.module$copy_to_clipboard = shadow.js.nativeProvides["copy-to-clipboard"] = shadow$bridge("copy-to-clipboard");
module$shadow_js_shim_module$copy_to_clipboard.default = shadow.js.shim.module$copy_to_clipboard;
